import { z } from 'zod';
/**
 * Currency code — ISO-4217 alpha-3 uppercase.
 *
 * SCRUM-289 (DS-021 §9, Payments BC slice 1) — backs the `char(3)` currency
 * column every `payments.folio` / `payments.payment` row carries alongside its
 * `BIGINT` cents amount (money is `Cents`; the currency frames it). Resolved to
 * the organization default at freeze (USD today — no per-property currency
 * field exists yet); one folio = one currency; no FX in the collection path.
 *
 * We validate the SHAPE only (`^[A-Z]{3}$`), not membership in the live ISO-4217
 * registry — mirroring `country-code.ts`. The registry mutates (additions,
 * deprecations, the special `XXX` "no currency" and `XTS` testing codes) and an
 * authoritative codelist is costly to maintain. Closed-set semantic validation
 * (e.g. an organization's enabled currencies) lives outside this VO; consumers
 * that need a closed set MUST layer their own enum on top.
 */
export const CURRENCY_CODE_PATTERN = /^[A-Z]{3}$/u;
export const currencyCodeSchema = z
    .string()
    .regex(CURRENCY_CODE_PATTERN, 'Must be ISO-4217 alpha-3 uppercase (e.g. "USD", "EUR")')
    .brand();
//# sourceMappingURL=currency-code.js.map